export const logMessage = ({ type, message  }) => ({
  type: 'nuxiba_logMessage',
  messageType: type,
  message
})

